import { render, staticRenderFns } from "./ModalSamePerson.vue?vue&type=template&id=21ad598a"
import script from "./ModalSamePerson.vue?vue&type=script&lang=js"
export * from "./ModalSamePerson.vue?vue&type=script&lang=js"
import style0 from "./ModalSamePerson.vue?vue&type=style&index=0&id=21ad598a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports